var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 975,
    height: 906,
    viewBox: "0 0 975 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_50_951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7037,
    height: 598.773,
    transform: "matrix(-0.644526 0.764583 0.765013 0.644014 267.566 248.899)",
    fill: "url(#paint0_linear_50_951)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_50_951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3592,
    height: 257.36,
    transform: "matrix(-0.644526 0.764583 0.765013 0.644014 290.359 272.887)",
    fill: "url(#paint1_linear_50_951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.6
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M512.482 510.98C512.218 510.809 512.143 510.455 512.314 510.19C512.486 509.925 512.839 509.85 513.104 510.022C513.368 510.194 513.443 510.547 513.272 510.812C513.1 511.077 512.747 511.152 512.482 510.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.223 512.605C509.025 512.476 508.969 512.211 509.097 512.013C509.226 511.814 509.491 511.758 509.689 511.886C509.887 512.015 509.944 512.281 509.815 512.479C509.687 512.677 509.422 512.734 509.223 512.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.584 502.445C504.386 502.316 504.329 502.05 504.458 501.852C504.586 501.653 504.852 501.597 505.05 501.726C505.248 501.855 505.304 502.12 505.176 502.318C505.047 502.517 504.782 502.573 504.584 502.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.235 515.18C525.037 515.051 524.98 514.785 525.109 514.587C525.238 514.388 525.503 514.332 525.701 514.461C525.899 514.59 525.956 514.855 525.827 515.053C525.698 515.252 525.433 515.308 525.235 515.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M533.353 528.626C533.089 528.454 533.013 528.101 533.185 527.836C533.357 527.571 533.71 527.496 533.974 527.668C534.239 527.839 534.314 528.193 534.143 528.458C533.971 528.723 533.618 528.798 533.353 528.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.315 526.309C541.183 526.223 541.145 526.046 541.231 525.914C541.317 525.782 541.493 525.744 541.625 525.83C541.758 525.916 541.795 526.092 541.709 526.225C541.624 526.357 541.447 526.395 541.315 526.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.147 520.791C507.015 520.705 506.978 520.528 507.063 520.396C507.149 520.264 507.326 520.226 507.458 520.312C507.59 520.398 507.627 520.575 507.542 520.707C507.456 520.839 507.279 520.877 507.147 520.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.982 486.897C454.85 486.811 454.812 486.634 454.898 486.502C454.984 486.37 455.16 486.332 455.292 486.418C455.425 486.504 455.462 486.681 455.376 486.813C455.291 486.945 455.114 486.983 454.982 486.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.287 457.012C437.155 456.926 437.117 456.749 437.203 456.617C437.288 456.485 437.465 456.447 437.597 456.533C437.729 456.619 437.767 456.796 437.681 456.928C437.595 457.06 437.419 457.098 437.287 457.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.618 468.438C416.486 468.352 416.448 468.175 416.534 468.043C416.62 467.911 416.796 467.873 416.928 467.959C417.06 468.045 417.098 468.221 417.012 468.354C416.926 468.486 416.75 468.523 416.618 468.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.711 566.576C590.578 566.49 590.541 566.313 590.627 566.181C590.712 566.049 590.889 566.011 591.021 566.097C591.153 566.183 591.191 566.36 591.105 566.492C591.019 566.624 590.843 566.662 590.711 566.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M602.682 555.97C602.55 555.884 602.513 555.707 602.598 555.575C602.684 555.442 602.861 555.405 602.993 555.491C603.125 555.576 603.162 555.753 603.077 555.885C602.991 556.018 602.814 556.055 602.682 555.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M609.399 568.165C609.267 568.079 609.229 567.903 609.315 567.77C609.401 567.638 609.577 567.6 609.709 567.686C609.841 567.772 609.879 567.949 609.793 568.081C609.708 568.213 609.531 568.251 609.399 568.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M592.186 577.41C592.054 577.324 592.016 577.147 592.102 577.015C592.188 576.883 592.364 576.845 592.497 576.931C592.629 577.017 592.666 577.194 592.58 577.326C592.495 577.458 592.318 577.496 592.186 577.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M541.452 530.823C541.32 530.737 541.282 530.56 541.368 530.428C541.453 530.296 541.63 530.258 541.762 530.344C541.894 530.43 541.932 530.607 541.846 530.739C541.76 530.871 541.584 530.909 541.452 530.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M502.032 529.727C501.9 529.641 501.862 529.464 501.948 529.332C502.034 529.199 502.21 529.162 502.342 529.248C502.474 529.333 502.512 529.51 502.426 529.643C502.341 529.775 502.164 529.812 502.032 529.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M457.645 497.479C457.513 497.393 457.475 497.217 457.561 497.084C457.647 496.952 457.823 496.915 457.956 497C458.088 497.086 458.125 497.263 458.039 497.395C457.954 497.527 457.777 497.565 457.645 497.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M583.584 553.434C583.452 553.348 583.414 553.171 583.5 553.039C583.586 552.907 583.762 552.869 583.894 552.955C584.026 553.041 584.064 553.218 583.978 553.35C583.892 553.482 583.716 553.52 583.584 553.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.935 504.736C536.803 504.651 536.765 504.474 536.851 504.342C536.937 504.209 537.113 504.172 537.246 504.258C537.378 504.343 537.415 504.52 537.33 504.652C537.244 504.785 537.067 504.822 536.935 504.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.396 480.315C500.264 480.229 500.226 480.052 500.312 479.92C500.398 479.787 500.574 479.75 500.706 479.836C500.839 479.921 500.876 480.098 500.79 480.23C500.705 480.363 500.528 480.4 500.396 480.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.92 537.351C538.788 537.265 538.751 537.088 538.836 536.956C538.922 536.824 539.099 536.786 539.231 536.872C539.363 536.958 539.4 537.134 539.315 537.267C539.229 537.399 539.052 537.437 538.92 537.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M555.67 548.235C555.538 548.149 555.501 547.972 555.587 547.84C555.672 547.708 555.849 547.67 555.981 547.756C556.113 547.842 556.151 548.019 556.065 548.151C555.979 548.283 555.803 548.321 555.67 548.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M584.916 546.129C584.784 546.043 584.746 545.866 584.832 545.734C584.917 545.602 585.094 545.564 585.226 545.65C585.358 545.736 585.396 545.912 585.31 546.045C585.224 546.177 585.048 546.215 584.916 546.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M528.899 507.687C528.767 507.601 528.729 507.425 528.815 507.292C528.901 507.16 529.077 507.122 529.209 507.208C529.341 507.294 529.379 507.471 529.293 507.603C529.208 507.735 529.031 507.773 528.899 507.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M531.9 539.26C531.768 539.174 531.73 538.997 531.816 538.865C531.902 538.733 532.078 538.695 532.211 538.781C532.343 538.867 532.38 539.043 532.294 539.176C532.209 539.308 532.032 539.346 531.9 539.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M559.302 560.468C559.169 560.382 559.132 560.205 559.218 560.073C559.303 559.941 559.48 559.903 559.612 559.989C559.744 560.075 559.782 560.252 559.696 560.384C559.61 560.516 559.434 560.554 559.302 560.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M576.643 548.925C576.511 548.84 576.474 548.663 576.559 548.531C576.645 548.398 576.822 548.361 576.954 548.447C577.086 548.532 577.123 548.709 577.038 548.841C576.952 548.974 576.775 549.011 576.643 548.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428.279 451.5C428.147 451.414 428.109 451.237 428.195 451.105C428.281 450.973 428.457 450.935 428.589 451.021C428.721 451.107 428.759 451.284 428.673 451.416C428.588 451.548 428.411 451.586 428.279 451.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M473.17 466.708C473.038 466.623 473 466.446 473.086 466.313C473.171 466.181 473.348 466.144 473.48 466.229C473.612 466.315 473.65 466.492 473.564 466.624C473.478 466.757 473.302 466.794 473.17 466.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M428.062 465.999C427.93 465.913 427.892 465.736 427.978 465.604C428.064 465.471 428.24 465.434 428.373 465.52C428.505 465.605 428.542 465.782 428.456 465.914C428.371 466.047 428.194 466.084 428.062 465.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M487.204 507.492C486.94 507.321 486.864 506.967 487.036 506.702C487.208 506.437 487.561 506.362 487.825 506.534C488.09 506.705 488.165 507.059 487.993 507.324C487.822 507.589 487.468 507.664 487.204 507.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M477.742 491.131C477.477 490.959 477.402 490.605 477.574 490.341C477.745 490.076 478.099 490 478.363 490.172C478.628 490.344 478.703 490.698 478.531 490.963C478.36 491.227 478.006 491.303 477.742 491.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.296 482.824C483.097 482.695 483.041 482.43 483.17 482.231C483.298 482.033 483.563 481.976 483.762 482.105C483.96 482.234 484.016 482.499 483.888 482.698C483.759 482.896 483.494 482.953 483.296 482.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.501 518.708C483.302 518.579 483.246 518.313 483.374 518.115C483.503 517.917 483.768 517.86 483.966 517.989C484.165 518.118 484.221 518.383 484.092 518.581C483.964 518.78 483.699 518.836 483.501 518.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.955 471.88C400.756 471.751 400.7 471.486 400.829 471.288C400.957 471.089 401.222 471.033 401.42 471.161C401.619 471.29 401.675 471.556 401.546 471.754C401.418 471.953 401.153 472.009 400.955 471.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.89 568.713C558.691 568.584 558.635 568.319 558.764 568.12C558.892 567.922 559.157 567.865 559.355 567.994C559.554 568.123 559.61 568.388 559.481 568.587C559.353 568.785 559.088 568.842 558.89 568.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.283 583.881C594.084 583.752 594.028 583.486 594.157 583.288C594.285 583.089 594.55 583.033 594.749 583.162C594.947 583.291 595.003 583.556 594.875 583.754C594.746 583.953 594.481 584.009 594.283 583.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.562 576.94C604.364 576.811 604.308 576.546 604.436 576.348C604.565 576.149 604.83 576.093 605.028 576.221C605.226 576.35 605.283 576.616 605.154 576.814C605.025 577.013 604.76 577.069 604.562 576.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.674 495.078C491.476 494.949 491.42 494.684 491.548 494.485C491.677 494.287 491.942 494.23 492.14 494.359C492.339 494.488 492.395 494.753 492.266 494.952C492.138 495.15 491.873 495.207 491.674 495.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.819 539.86C521.621 539.731 521.564 539.466 521.693 539.268C521.822 539.069 522.087 539.013 522.285 539.141C522.483 539.27 522.54 539.536 522.411 539.734C522.282 539.932 522.017 539.989 521.819 539.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.842 510.982C454.644 510.854 454.588 510.588 454.716 510.39C454.845 510.191 455.11 510.135 455.308 510.264C455.507 510.392 455.563 510.658 455.434 510.856C455.306 511.055 455.041 511.111 454.842 510.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.995 453.489C401.797 453.36 401.74 453.094 401.869 452.896C401.997 452.697 402.262 452.641 402.461 452.77C402.659 452.899 402.715 453.164 402.587 453.362C402.458 453.561 402.193 453.617 401.995 453.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.793 436.58C404.594 436.451 404.538 436.185 404.667 435.987C404.795 435.788 405.06 435.732 405.259 435.861C405.457 435.99 405.513 436.255 405.385 436.453C405.256 436.652 404.991 436.708 404.793 436.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M463.4 470.235C463.136 470.063 463.061 469.71 463.232 469.445C463.404 469.18 463.757 469.105 464.022 469.277C464.286 469.448 464.361 469.802 464.19 470.067C464.018 470.332 463.665 470.407 463.4 470.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.425 453.226C474.161 453.054 474.086 452.7 474.257 452.436C474.429 452.171 474.782 452.096 475.047 452.267C475.311 452.439 475.386 452.793 475.215 453.058C475.043 453.323 474.69 453.398 474.425 453.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.66 467.5C447.461 467.371 447.405 467.106 447.534 466.907C447.662 466.709 447.927 466.652 448.126 466.781C448.324 466.91 448.38 467.175 448.252 467.374C448.123 467.572 447.858 467.628 447.66 467.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M442.11 450.616C441.846 450.444 441.771 450.09 441.942 449.825C442.114 449.56 442.467 449.485 442.732 449.657C442.996 449.829 443.071 450.183 442.9 450.447C442.728 450.712 442.375 450.787 442.11 450.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M407.396 452.233C407.132 452.061 407.057 451.707 407.228 451.442C407.4 451.178 407.753 451.102 408.018 451.274C408.282 451.446 408.357 451.8 408.186 452.064C408.014 452.329 407.661 452.404 407.396 452.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M435.084 470.902C434.819 470.731 434.744 470.377 434.916 470.112C435.087 469.847 435.441 469.772 435.705 469.944C435.97 470.116 436.045 470.469 435.873 470.734C435.702 470.999 435.348 471.074 435.084 470.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M569.792 564.219C569.527 564.047 569.452 563.693 569.624 563.429C569.795 563.164 570.149 563.088 570.413 563.26C570.677 563.432 570.753 563.786 570.581 564.051C570.41 564.315 570.056 564.391 569.792 564.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M597.715 563.637C597.45 563.465 597.375 563.111 597.547 562.847C597.718 562.582 598.072 562.506 598.336 562.678C598.601 562.85 598.676 563.204 598.504 563.469C598.333 563.733 597.979 563.809 597.715 563.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M421.867 451.42C421.603 451.248 421.527 450.894 421.699 450.63C421.871 450.365 422.224 450.289 422.488 450.461C422.753 450.633 422.828 450.987 422.657 451.252C422.485 451.516 422.131 451.592 421.867 451.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M568.776 533.258C568.512 533.086 568.437 532.732 568.608 532.468C568.78 532.203 569.133 532.128 569.398 532.299C569.662 532.471 569.737 532.825 569.566 533.09C569.394 533.354 569.041 533.43 568.776 533.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M578.343 532.664C578.078 532.492 578.003 532.138 578.175 531.874C578.346 531.609 578.7 531.534 578.964 531.705C579.228 531.877 579.304 532.231 579.132 532.496C578.96 532.76 578.607 532.836 578.343 532.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M570.319 549.241C570.055 549.069 569.979 548.716 570.151 548.451C570.323 548.186 570.676 548.111 570.94 548.283C571.205 548.454 571.28 548.808 571.109 549.073C570.937 549.338 570.583 549.413 570.319 549.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.52 539.285C555.322 539.156 555.266 538.891 555.394 538.692C555.523 538.494 555.788 538.437 555.986 538.566C556.184 538.695 556.241 538.96 556.112 539.159C555.983 539.357 555.718 539.414 555.52 539.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M477.156 384.049C476.892 383.877 476.816 383.523 476.988 383.259C477.16 382.994 477.513 382.918 477.777 383.09C478.042 383.262 478.117 383.616 477.946 383.881C477.774 384.145 477.42 384.221 477.156 384.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.892 385.675C473.694 385.546 473.638 385.28 473.766 385.082C473.895 384.883 474.16 384.827 474.358 384.956C474.557 385.085 474.613 385.35 474.484 385.548C474.356 385.747 474.091 385.803 473.892 385.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.256 375.513C469.057 375.384 469.001 375.119 469.13 374.92C469.258 374.722 469.523 374.665 469.721 374.794C469.92 374.923 469.976 375.188 469.847 375.387C469.719 375.585 469.454 375.642 469.256 375.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.906 388.249C489.708 388.12 489.651 387.855 489.78 387.656C489.909 387.458 490.174 387.401 490.372 387.53C490.57 387.659 490.627 387.924 490.498 388.123C490.369 388.321 490.104 388.378 489.906 388.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M498.024 401.696C497.76 401.524 497.685 401.17 497.856 400.905C498.028 400.64 498.381 400.565 498.646 400.737C498.91 400.909 498.985 401.263 498.814 401.527C498.642 401.792 498.289 401.867 498.024 401.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.986 399.378C505.854 399.292 505.816 399.116 505.902 398.983C505.988 398.851 506.164 398.813 506.296 398.899C506.428 398.985 506.466 399.162 506.38 399.294C506.295 399.426 506.118 399.464 505.986 399.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.819 393.86C471.687 393.775 471.649 393.598 471.735 393.466C471.821 393.333 471.997 393.296 472.129 393.381C472.261 393.467 472.299 393.644 472.213 393.776C472.127 393.909 471.951 393.946 471.819 393.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.653 359.966C419.521 359.881 419.483 359.704 419.569 359.572C419.655 359.439 419.831 359.402 419.963 359.487C420.096 359.573 420.133 359.75 420.047 359.882C419.962 360.015 419.785 360.052 419.653 359.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.959 330.081C401.826 329.996 401.789 329.819 401.875 329.687C401.96 329.554 402.137 329.517 402.269 329.602C402.401 329.688 402.439 329.865 402.353 329.997C402.267 330.13 402.091 330.167 401.959 330.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.289 341.508C381.157 341.422 381.119 341.245 381.205 341.113C381.291 340.981 381.467 340.943 381.599 341.029C381.731 341.115 381.769 341.292 381.683 341.424C381.597 341.556 381.421 341.594 381.289 341.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.381 439.644C555.249 439.558 555.212 439.382 555.297 439.249C555.383 439.117 555.56 439.08 555.692 439.165C555.824 439.251 555.862 439.428 555.776 439.56C555.69 439.692 555.513 439.73 555.381 439.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M567.354 429.039C567.222 428.953 567.184 428.776 567.27 428.644C567.356 428.512 567.532 428.474 567.664 428.56C567.796 428.646 567.834 428.823 567.748 428.955C567.663 429.087 567.486 429.125 567.354 429.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M574.071 441.235C573.939 441.149 573.901 440.972 573.987 440.84C574.073 440.707 574.249 440.67 574.381 440.756C574.513 440.841 574.551 441.018 574.465 441.15C574.38 441.283 574.203 441.32 574.071 441.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M556.858 450.479C556.726 450.393 556.688 450.216 556.774 450.084C556.86 449.952 557.036 449.914 557.168 450C557.3 450.086 557.338 450.262 557.252 450.395C557.166 450.527 556.99 450.565 556.858 450.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M506.123 403.891C505.991 403.805 505.953 403.629 506.039 403.496C506.125 403.364 506.301 403.327 506.433 403.412C506.565 403.498 506.603 403.675 506.517 403.807C506.431 403.939 506.255 403.977 506.123 403.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M466.704 402.796C466.571 402.71 466.534 402.533 466.62 402.401C466.705 402.269 466.882 402.231 467.014 402.317C467.146 402.403 467.184 402.58 467.098 402.712C467.012 402.844 466.836 402.882 466.704 402.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M422.317 370.548C422.185 370.462 422.147 370.285 422.233 370.153C422.319 370.021 422.495 369.983 422.627 370.069C422.76 370.155 422.797 370.331 422.711 370.464C422.626 370.596 422.449 370.634 422.317 370.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M548.255 426.502C548.123 426.417 548.086 426.24 548.171 426.108C548.257 425.975 548.434 425.938 548.566 426.023C548.698 426.109 548.735 426.286 548.65 426.418C548.564 426.551 548.387 426.588 548.255 426.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.607 377.805C501.475 377.719 501.437 377.542 501.523 377.41C501.609 377.278 501.785 377.24 501.917 377.326C502.05 377.412 502.087 377.589 502.001 377.721C501.916 377.853 501.739 377.891 501.607 377.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.068 353.383C464.936 353.297 464.898 353.12 464.984 352.988C465.07 352.856 465.246 352.818 465.378 352.904C465.51 352.99 465.548 353.167 465.462 353.299C465.377 353.431 465.2 353.469 465.068 353.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.592 410.42C503.459 410.334 503.422 410.157 503.508 410.025C503.593 409.893 503.77 409.855 503.902 409.941C504.034 410.027 504.072 410.204 503.986 410.336C503.9 410.468 503.724 410.506 503.592 410.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M520.342 421.304C520.209 421.218 520.172 421.041 520.258 420.909C520.343 420.776 520.52 420.739 520.652 420.825C520.784 420.91 520.822 421.087 520.736 421.219C520.65 421.352 520.474 421.389 520.342 421.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M549.587 419.198C549.455 419.112 549.418 418.935 549.503 418.803C549.589 418.671 549.766 418.633 549.898 418.719C550.03 418.805 550.067 418.982 549.982 419.114C549.896 419.246 549.719 419.284 549.587 419.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M493.57 380.757C493.438 380.671 493.4 380.494 493.486 380.362C493.572 380.229 493.748 380.192 493.88 380.278C494.012 380.363 494.05 380.54 493.964 380.672C493.879 380.805 493.702 380.842 493.57 380.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M496.572 412.328C496.44 412.242 496.402 412.065 496.488 411.933C496.574 411.801 496.75 411.763 496.882 411.849C497.014 411.935 497.052 412.112 496.966 412.244C496.88 412.376 496.704 412.414 496.572 412.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M523.973 433.537C523.841 433.451 523.804 433.275 523.889 433.142C523.975 433.01 524.152 432.972 524.284 433.058C524.416 433.144 524.453 433.321 524.368 433.453C524.282 433.585 524.105 433.623 523.973 433.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M541.315 421.995C541.183 421.909 541.145 421.732 541.231 421.6C541.317 421.468 541.493 421.43 541.625 421.516C541.758 421.602 541.795 421.779 541.709 421.911C541.624 422.043 541.447 422.081 541.315 421.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M392.95 324.569C392.818 324.483 392.78 324.307 392.866 324.174C392.952 324.042 393.128 324.004 393.26 324.09C393.392 324.176 393.43 324.353 393.344 324.485C393.259 324.617 393.082 324.655 392.95 324.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M437.841 339.778C437.709 339.692 437.672 339.515 437.757 339.383C437.843 339.251 438.02 339.213 438.152 339.299C438.284 339.385 438.321 339.561 438.236 339.694C438.15 339.826 437.973 339.864 437.841 339.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M392.734 339.068C392.602 338.982 392.564 338.805 392.65 338.673C392.736 338.541 392.912 338.503 393.044 338.589C393.176 338.675 393.214 338.852 393.128 338.984C393.043 339.116 392.866 339.154 392.734 339.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M451.874 380.561C451.609 380.389 451.534 380.035 451.706 379.77C451.877 379.506 452.231 379.43 452.495 379.602C452.76 379.774 452.835 380.128 452.663 380.392C452.492 380.657 452.138 380.733 451.874 380.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M442.415 364.2C442.15 364.029 442.075 363.675 442.247 363.41C442.418 363.145 442.772 363.07 443.036 363.242C443.301 363.413 443.376 363.767 443.204 364.032C443.033 364.297 442.679 364.372 442.415 364.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.967 355.892C447.769 355.764 447.713 355.498 447.841 355.3C447.97 355.101 448.235 355.045 448.433 355.174C448.632 355.302 448.688 355.568 448.559 355.766C448.431 355.965 448.166 356.021 447.967 355.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.172 391.776C447.973 391.647 447.917 391.382 448.046 391.183C448.174 390.985 448.439 390.928 448.637 391.057C448.836 391.186 448.892 391.451 448.763 391.65C448.635 391.848 448.37 391.905 448.172 391.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.626 344.95C365.427 344.821 365.371 344.555 365.5 344.357C365.628 344.158 365.893 344.102 366.092 344.231C366.29 344.36 366.346 344.625 366.218 344.823C366.089 345.022 365.824 345.078 365.626 344.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.561 441.781C523.363 441.652 523.306 441.387 523.435 441.189C523.564 440.99 523.829 440.934 524.027 441.062C524.225 441.191 524.282 441.457 524.153 441.655C524.024 441.854 523.759 441.91 523.561 441.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.954 456.949C558.756 456.82 558.699 456.555 558.828 456.356C558.956 456.158 559.221 456.101 559.42 456.23C559.618 456.359 559.674 456.624 559.546 456.823C559.417 457.021 559.152 457.078 558.954 456.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.234 450.009C569.036 449.88 568.979 449.614 569.108 449.416C569.237 449.218 569.502 449.161 569.7 449.29C569.898 449.419 569.955 449.684 569.826 449.882C569.697 450.081 569.432 450.137 569.234 450.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.346 368.147C456.147 368.019 456.091 367.753 456.22 367.555C456.348 367.356 456.613 367.3 456.812 367.429C457.01 367.557 457.066 367.823 456.938 368.021C456.809 368.22 456.544 368.276 456.346 368.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.491 412.929C486.293 412.8 486.236 412.534 486.365 412.336C486.493 412.137 486.758 412.081 486.957 412.21C487.155 412.339 487.211 412.604 487.083 412.802C486.954 413.001 486.689 413.057 486.491 412.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.514 384.051C419.316 383.922 419.26 383.657 419.388 383.458C419.517 383.26 419.782 383.203 419.98 383.332C420.179 383.461 420.235 383.726 420.106 383.925C419.978 384.123 419.713 384.18 419.514 384.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.666 326.557C366.468 326.428 366.411 326.163 366.54 325.964C366.668 325.766 366.933 325.709 367.132 325.838C367.33 325.967 367.386 326.232 367.258 326.431C367.129 326.629 366.864 326.686 366.666 326.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.462 309.65C369.264 309.521 369.208 309.256 369.336 309.057C369.465 308.859 369.73 308.802 369.928 308.931C370.127 309.06 370.183 309.325 370.054 309.524C369.926 309.722 369.661 309.779 369.462 309.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M428.071 343.305C427.807 343.133 427.732 342.779 427.903 342.514C428.075 342.249 428.428 342.174 428.693 342.346C428.957 342.518 429.032 342.872 428.861 343.136C428.689 343.401 428.336 343.476 428.071 343.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.098 326.295C438.834 326.123 438.759 325.769 438.93 325.504C439.102 325.239 439.455 325.164 439.72 325.336C439.984 325.508 440.059 325.862 439.888 326.126C439.716 326.391 439.363 326.466 439.098 326.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.331 340.568C412.133 340.439 412.076 340.174 412.205 339.975C412.333 339.777 412.598 339.72 412.797 339.849C412.995 339.978 413.051 340.243 412.923 340.442C412.794 340.64 412.529 340.697 412.331 340.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M406.781 323.684C406.517 323.512 406.442 323.158 406.613 322.894C406.785 322.629 407.138 322.553 407.403 322.725C407.667 322.897 407.742 323.251 407.571 323.516C407.399 323.78 407.046 323.856 406.781 323.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.069 325.302C371.805 325.13 371.73 324.776 371.901 324.512C372.073 324.247 372.426 324.172 372.691 324.343C372.955 324.515 373.03 324.869 372.859 325.134C372.687 325.398 372.334 325.474 372.069 325.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M399.756 343.972C399.491 343.8 399.416 343.446 399.588 343.181C399.759 342.917 400.113 342.841 400.377 343.013C400.641 343.185 400.717 343.539 400.545 343.804C400.374 344.068 400.02 344.144 399.756 343.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M534.463 437.288C534.198 437.116 534.123 436.763 534.295 436.498C534.466 436.233 534.82 436.158 535.084 436.33C535.348 436.501 535.424 436.855 535.252 437.12C535.081 437.385 534.727 437.46 534.463 437.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M562.388 436.706C562.124 436.535 562.049 436.181 562.22 435.916C562.392 435.651 562.745 435.576 563.01 435.748C563.274 435.919 563.35 436.273 563.178 436.538C563.006 436.803 562.653 436.878 562.388 436.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M386.538 324.489C386.274 324.317 386.198 323.964 386.37 323.699C386.541 323.434 386.895 323.359 387.159 323.531C387.424 323.702 387.499 324.056 387.327 324.321C387.156 324.586 386.802 324.661 386.538 324.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M533.45 406.327C533.186 406.156 533.11 405.802 533.282 405.537C533.454 405.272 533.807 405.197 534.071 405.369C534.336 405.54 534.411 405.894 534.239 406.159C534.068 406.424 533.714 406.499 533.45 406.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M543.016 405.733C542.752 405.562 542.677 405.208 542.848 404.943C543.02 404.678 543.373 404.603 543.638 404.775C543.902 404.946 543.977 405.3 543.806 405.565C543.634 405.83 543.281 405.905 543.016 405.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M534.989 422.31C534.725 422.138 534.649 421.784 534.821 421.519C534.993 421.255 535.346 421.179 535.61 421.351C535.875 421.523 535.95 421.877 535.779 422.141C535.607 422.406 535.253 422.481 534.989 422.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.191 412.353C519.993 412.224 519.936 411.959 520.065 411.76C520.194 411.562 520.459 411.505 520.657 411.634C520.855 411.763 520.912 412.028 520.783 412.227C520.654 412.425 520.389 412.482 520.191 412.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M327.002 339.832C326.737 339.66 326.662 339.306 326.834 339.042C327.005 338.777 327.359 338.702 327.623 338.873C327.888 339.045 327.963 339.399 327.791 339.664C327.62 339.929 327.266 340.004 327.002 339.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.74 341.458C323.542 341.329 323.485 341.064 323.614 340.865C323.743 340.667 324.008 340.61 324.206 340.739C324.404 340.868 324.46 341.133 324.332 341.332C324.203 341.53 323.938 341.587 323.74 341.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.103 331.296C318.905 331.167 318.849 330.902 318.977 330.704C319.106 330.505 319.371 330.449 319.569 330.577C319.767 330.706 319.824 330.972 319.695 331.17C319.566 331.369 319.301 331.425 319.103 331.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.754 344.031C339.555 343.902 339.499 343.637 339.628 343.439C339.756 343.24 340.021 343.184 340.22 343.312C340.418 343.441 340.474 343.707 340.346 343.905C340.217 344.104 339.952 344.16 339.754 344.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M347.873 357.478C347.608 357.306 347.533 356.952 347.705 356.687C347.876 356.423 348.23 356.347 348.494 356.519C348.759 356.691 348.834 357.045 348.662 357.31C348.491 357.574 348.137 357.65 347.873 357.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.835 355.161C355.702 355.076 355.665 354.899 355.751 354.766C355.836 354.634 356.013 354.597 356.145 354.682C356.277 354.768 356.315 354.945 356.229 355.077C356.143 355.21 355.967 355.247 355.835 355.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.667 349.643C321.535 349.557 321.497 349.38 321.583 349.248C321.668 349.116 321.845 349.078 321.977 349.164C322.109 349.25 322.147 349.426 322.061 349.559C321.975 349.691 321.799 349.729 321.667 349.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.501 315.75C269.368 315.664 269.331 315.487 269.417 315.355C269.502 315.222 269.679 315.185 269.811 315.271C269.943 315.357 269.981 315.533 269.895 315.666C269.809 315.798 269.633 315.835 269.501 315.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.807 285.864C251.675 285.778 251.638 285.601 251.723 285.469C251.809 285.337 251.986 285.299 252.118 285.385C252.25 285.471 252.287 285.647 252.202 285.78C252.116 285.912 251.939 285.949 251.807 285.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.137 297.29C231.005 297.204 230.968 297.028 231.053 296.895C231.139 296.763 231.316 296.725 231.448 296.811C231.58 296.897 231.617 297.074 231.532 297.206C231.446 297.338 231.269 297.376 231.137 297.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.229 395.428C405.097 395.342 405.059 395.165 405.145 395.033C405.231 394.9 405.407 394.863 405.539 394.949C405.672 395.034 405.709 395.211 405.623 395.343C405.538 395.476 405.361 395.513 405.229 395.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M417.202 384.822C417.07 384.736 417.032 384.559 417.118 384.427C417.203 384.295 417.38 384.257 417.512 384.343C417.644 384.429 417.682 384.606 417.596 384.738C417.51 384.87 417.334 384.908 417.202 384.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M423.918 397.018C423.786 396.932 423.749 396.755 423.834 396.623C423.92 396.491 424.097 396.453 424.229 396.539C424.361 396.625 424.398 396.801 424.313 396.934C424.227 397.066 424.05 397.104 423.918 397.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M406.706 406.262C406.574 406.176 406.536 405.999 406.622 405.867C406.707 405.735 406.884 405.697 407.016 405.783C407.148 405.869 407.186 406.046 407.1 406.178C407.014 406.31 406.838 406.348 406.706 406.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M355.97 359.674C355.838 359.589 355.801 359.412 355.886 359.28C355.972 359.147 356.149 359.11 356.281 359.196C356.413 359.281 356.45 359.458 356.365 359.59C356.279 359.723 356.102 359.76 355.97 359.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M316.555 358.579C316.423 358.493 316.386 358.316 316.471 358.184C316.557 358.052 316.734 358.014 316.866 358.1C316.998 358.186 317.035 358.363 316.95 358.495C316.864 358.627 316.687 358.665 316.555 358.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M272.165 326.331C272.033 326.245 271.995 326.068 272.081 325.936C272.166 325.804 272.343 325.766 272.475 325.852C272.607 325.938 272.645 326.115 272.559 326.247C272.473 326.379 272.297 326.417 272.165 326.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M398.103 382.286C397.971 382.2 397.933 382.023 398.019 381.891C398.105 381.759 398.281 381.721 398.414 381.807C398.546 381.893 398.583 382.069 398.497 382.202C398.412 382.334 398.235 382.371 398.103 382.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.455 333.588C351.323 333.502 351.285 333.325 351.371 333.193C351.456 333.061 351.633 333.023 351.765 333.109C351.897 333.195 351.935 333.372 351.849 333.504C351.763 333.636 351.587 333.674 351.455 333.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.916 309.166C314.784 309.08 314.746 308.904 314.832 308.771C314.917 308.639 315.094 308.601 315.226 308.687C315.358 308.773 315.396 308.95 315.31 309.082C315.224 309.214 315.048 309.252 314.916 309.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.439 366.203C353.307 366.117 353.269 365.941 353.355 365.808C353.441 365.676 353.617 365.638 353.749 365.724C353.882 365.81 353.919 365.987 353.833 366.119C353.748 366.251 353.571 366.289 353.439 366.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M370.189 377.087C370.057 377.001 370.019 376.824 370.105 376.692C370.191 376.56 370.367 376.522 370.499 376.608C370.632 376.694 370.669 376.87 370.583 377.003C370.498 377.135 370.321 377.173 370.189 377.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M399.435 374.98C399.303 374.894 399.265 374.718 399.351 374.585C399.437 374.453 399.613 374.416 399.745 374.501C399.878 374.587 399.915 374.764 399.829 374.896C399.744 375.028 399.567 375.066 399.435 374.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M343.418 336.54C343.285 336.454 343.248 336.277 343.334 336.145C343.419 336.013 343.596 335.975 343.728 336.061C343.86 336.147 343.898 336.323 343.812 336.456C343.726 336.588 343.55 336.626 343.418 336.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M346.419 368.111C346.287 368.026 346.25 367.849 346.335 367.716C346.421 367.584 346.598 367.547 346.73 367.632C346.862 367.718 346.9 367.895 346.814 368.027C346.728 368.16 346.552 368.197 346.419 368.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373.821 389.319C373.689 389.234 373.651 389.057 373.737 388.925C373.823 388.792 373.999 388.755 374.131 388.841C374.263 388.926 374.301 389.103 374.215 389.235C374.13 389.368 373.953 389.405 373.821 389.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M391.163 377.777C391.03 377.691 390.993 377.515 391.079 377.382C391.164 377.25 391.341 377.212 391.473 377.298C391.605 377.384 391.643 377.561 391.557 377.693C391.471 377.825 391.295 377.863 391.163 377.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M242.797 280.352C242.665 280.267 242.628 280.09 242.713 279.958C242.799 279.825 242.976 279.788 243.108 279.873C243.24 279.959 243.278 280.136 243.192 280.268C243.106 280.401 242.929 280.438 242.797 280.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M287.688 295.56C287.556 295.474 287.518 295.297 287.604 295.165C287.69 295.033 287.866 294.995 287.998 295.081C288.131 295.167 288.168 295.344 288.082 295.476C287.997 295.608 287.82 295.646 287.688 295.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M242.581 294.85C242.449 294.764 242.411 294.588 242.497 294.455C242.582 294.323 242.759 294.285 242.891 294.371C243.023 294.457 243.061 294.634 242.975 294.766C242.889 294.898 242.713 294.936 242.581 294.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M301.723 336.344C301.459 336.172 301.384 335.818 301.555 335.553C301.727 335.289 302.08 335.213 302.345 335.385C302.609 335.557 302.684 335.911 302.513 336.176C302.341 336.44 301.988 336.516 301.723 336.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M292.261 319.984C291.996 319.812 291.921 319.458 292.093 319.193C292.264 318.928 292.618 318.853 292.882 319.025C293.146 319.197 293.222 319.551 293.05 319.815C292.878 320.08 292.525 320.155 292.261 319.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.815 311.676C297.617 311.547 297.56 311.281 297.689 311.083C297.818 310.884 298.083 310.828 298.281 310.957C298.479 311.086 298.535 311.351 298.407 311.549C298.278 311.748 298.013 311.804 297.815 311.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.02 347.559C297.822 347.43 297.766 347.165 297.894 346.967C298.023 346.768 298.288 346.712 298.486 346.84C298.684 346.969 298.741 347.235 298.612 347.433C298.483 347.632 298.218 347.688 298.02 347.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.473 300.733C215.275 300.604 215.219 300.339 215.347 300.14C215.476 299.942 215.741 299.885 215.939 300.014C216.137 300.143 216.194 300.408 216.065 300.607C215.937 300.805 215.672 300.862 215.473 300.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.409 397.564C373.211 397.436 373.154 397.17 373.283 396.972C373.412 396.773 373.677 396.717 373.875 396.846C374.073 396.974 374.13 397.24 374.001 397.438C373.872 397.637 373.607 397.693 373.409 397.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.802 412.732C408.604 412.603 408.548 412.338 408.676 412.139C408.805 411.941 409.07 411.884 409.268 412.013C409.467 412.142 409.523 412.407 409.394 412.606C409.266 412.804 409.001 412.861 408.802 412.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.082 405.792C418.884 405.663 418.827 405.398 418.956 405.199C419.084 405.001 419.349 404.944 419.548 405.073C419.746 405.202 419.802 405.467 419.674 405.666C419.545 405.864 419.28 405.921 419.082 405.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.194 323.93C305.996 323.801 305.939 323.536 306.068 323.337C306.197 323.139 306.462 323.082 306.66 323.211C306.858 323.34 306.915 323.605 306.786 323.804C306.657 324.002 306.392 324.058 306.194 323.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.339 368.712C336.14 368.583 336.084 368.318 336.213 368.119C336.341 367.921 336.606 367.864 336.805 367.993C337.003 368.122 337.059 368.387 336.931 368.586C336.802 368.784 336.537 368.841 336.339 368.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.362 339.834C269.164 339.705 269.107 339.44 269.236 339.241C269.365 339.043 269.63 338.986 269.828 339.115C270.026 339.244 270.083 339.509 269.954 339.708C269.825 339.906 269.56 339.963 269.362 339.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.514 282.34C216.316 282.211 216.26 281.946 216.388 281.747C216.517 281.549 216.782 281.493 216.98 281.621C217.178 281.75 217.235 282.015 217.106 282.214C216.978 282.412 216.713 282.469 216.514 282.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.311 265.432C219.113 265.303 219.057 265.038 219.185 264.839C219.314 264.641 219.579 264.584 219.777 264.713C219.975 264.842 220.032 265.107 219.903 265.306C219.774 265.504 219.509 265.561 219.311 265.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M277.923 299.088C277.658 298.916 277.583 298.562 277.755 298.297C277.926 298.033 278.28 297.957 278.544 298.129C278.808 298.301 278.884 298.655 278.712 298.919C278.541 299.184 278.187 299.26 277.923 299.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.946 282.079C288.682 281.907 288.606 281.553 288.778 281.288C288.95 281.023 289.303 280.948 289.567 281.12C289.832 281.292 289.907 281.646 289.736 281.91C289.564 282.175 289.211 282.25 288.946 282.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.178 296.351C261.98 296.222 261.924 295.957 262.052 295.759C262.181 295.56 262.446 295.504 262.644 295.632C262.843 295.761 262.899 296.027 262.77 296.225C262.642 296.424 262.377 296.48 262.178 296.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M256.632 279.467C256.367 279.295 256.292 278.941 256.464 278.677C256.635 278.412 256.989 278.337 257.253 278.508C257.517 278.68 257.593 279.034 257.421 279.299C257.25 279.564 256.896 279.639 256.632 279.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M221.915 281.085C221.65 280.913 221.575 280.559 221.747 280.295C221.918 280.03 222.272 279.955 222.536 280.126C222.801 280.298 222.876 280.652 222.704 280.917C222.533 281.182 222.179 281.257 221.915 281.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M249.6 299.755C249.336 299.583 249.261 299.229 249.432 298.965C249.604 298.7 249.957 298.624 250.222 298.796C250.486 298.968 250.561 299.322 250.39 299.587C250.218 299.851 249.865 299.927 249.6 299.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M384.311 393.072C384.047 392.9 383.972 392.546 384.143 392.281C384.315 392.016 384.668 391.941 384.933 392.113C385.197 392.285 385.272 392.639 385.101 392.903C384.929 393.168 384.576 393.243 384.311 393.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M412.234 392.49C411.97 392.318 411.895 391.964 412.066 391.699C412.238 391.434 412.591 391.359 412.856 391.531C413.12 391.703 413.195 392.057 413.024 392.321C412.852 392.586 412.499 392.661 412.234 392.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M236.384 280.272C236.119 280.101 236.044 279.747 236.216 279.482C236.387 279.217 236.741 279.142 237.005 279.314C237.269 279.486 237.345 279.839 237.173 280.104C237.001 280.369 236.648 280.444 236.384 280.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M383.298 362.111C383.033 361.939 382.958 361.585 383.13 361.32C383.301 361.055 383.655 360.98 383.919 361.152C384.184 361.324 384.259 361.678 384.087 361.942C383.916 362.207 383.562 362.282 383.298 362.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M392.862 361.517C392.598 361.345 392.523 360.991 392.694 360.726C392.866 360.461 393.219 360.386 393.484 360.558C393.748 360.73 393.823 361.084 393.652 361.348C393.48 361.613 393.127 361.688 392.862 361.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M384.839 378.093C384.574 377.921 384.499 377.567 384.671 377.302C384.842 377.038 385.196 376.962 385.46 377.134C385.724 377.306 385.8 377.66 385.628 377.925C385.457 378.189 385.103 378.265 384.839 378.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.04 368.136C369.841 368.007 369.785 367.742 369.914 367.544C370.042 367.345 370.307 367.289 370.506 367.417C370.704 367.546 370.76 367.812 370.632 368.01C370.503 368.209 370.238 368.265 370.04 368.136Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_50_951",
    x: 72.3656,
    y: 72.1991,
    width: 829.97,
    height: 760.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 88.35,
    result: "effect1_foregroundBlur_50_951"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_50_951",
    x: 156.592,
    y: 152.887,
    width: 450.65,
    height: 422.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_50_951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_951",
    x1: 14.3519,
    y1: 0,
    x2: 14.3519,
    y2: 598.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_951",
    x1: 10.6796,
    y1: 0,
    x2: 10.6796,
    y2: 257.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLight);
export default __webpack_public_path__ + "static/media/left-light.8e699dd991782136dab8415d7da610a2.svg";
export { ForwardRef as ReactComponent };